import { ILiveAgentConnection } from '@/types/agent';
import { handleRequest, safeStringify } from '@/utils';/**
 *
 * judge any live agent is available no matter what channel
 * NOTE: BE if will error, we can default think about it as available
 *
 */
import reporter from '@/utils/report';
export const IsAnyLiveAgentAvailableEnum = {
  UnAvailable: false,
  Available: true,
};

export async function isAnyLiveAgentAvailable() {

  let isLiveAgentAvailable = true;

  try {
    const res = await handleRequest<ILiveAgentConnection['PreCheckInbound']>('getPreCheckInbound', {}, { withNoRes: true });
    reporter.apiLog('[services, agent]#isAnyLiveAgentAvailable, data=', {
      level: 'debug',
      res: safeStringify(res),
    });
    if (res?.live_chat_can_inbound === IsAnyLiveAgentAvailableEnum.UnAvailable
      && res?.virtual_call_can_inbound === IsAnyLiveAgentAvailableEnum.UnAvailable) {
      isLiveAgentAvailable = false;
    }
  } catch (e) {
    isLiveAgentAvailable = true;
  }

  return isLiveAgentAvailable;
}
